import { render } from "./NervReticle.vue?vue&type=template&id=1d6befb2&scoped=true&ts=true"
import script from "./NervReticle.vue?vue&type=script&lang=ts"
export * from "./NervReticle.vue?vue&type=script&lang=ts"

import "./NervReticle.vue?vue&type=style&index=0&id=1d6befb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6befb2"]])

export default __exports__